import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
const points = ['Discusiones que se repiten cada vez que intentás ayudar.', 'No sabés qué decir cuando tu familiar rechaza tu ayuda.', 'Tu familiar insiste en hacer todo por su cuenta y rechaza que lo ayudes.', 'No sabés cuándo insistir, cuándo bajar el ritmo o cuándo hacer una pausa.', 'Cada situación difícil te deja agotada porque sentís que siempre tenés que improvisar.'];
export function PainPoints() {
  return <section className="bg-brand-ink px-4 py-16 sm:py-24" data-id="element-84" data-mp="21zlaslub1x56">
      <div className="mx-auto max-w-4xl" data-id="element-85" data-mp="21x05tnypn137">
        <header className="text-center" data-id="element-86" data-mp="1o0d9nnel0eyc">
          <h2 className="font-display text-3xl font-bold sm:text-5xl" data-id="element-87" data-mp="1o1enfzmzffjr">
            ¿Cuántos días más vas a terminar en discusión?
          </h2>
          <p className="mx-auto mt-6 max-w-3xl text-slate-300" data-id="element-88" data-mp="3id34c7crxs6s">
            Querés ayudar, pero tu familiar rechaza tu ayuda y terminás frustrada, agotada y sin saber qué hacer.
          </p>
          <p className="mt-4 font-semibold text-brand-light" data-id="element-89" data-mp="1z0f1v1h87i9j">
            El problema no es que no quieras ayudar. Es no tener claro qué hacer cuando tu ayuda es rechazada.
          </p>
        </header>
        <div className="mt-10 space-y-3" data-id="element-90" data-mp="27ti9uu93r2ws">
          {points.map((point, index) => <motion.div key={point} initial={{
          opacity: 0,
          x: -14
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.05
        }} className="flex gap-3 rounded-xl border border-red-900/70 bg-[#250c0c] p-4 sm:p-5" data-id="element-91" data-mp="27utcgqqta4mb" data-mpi={index}>
              <XCircleIcon className="mt-0.5 h-5 w-5 shrink-0 text-red-500" aria-hidden="true" data-id="element-92" data-mp="1p3k3cikydhv9" />
              <p className="text-sm leading-relaxed text-slate-200 sm:text-base" data-id="element-93" data-mp="1k34otnoxq4bp">
                {point}
              </p>
            </motion.div>)}
        </div>
        <p className="mt-12 text-center font-display text-2xl font-bold italic text-brand-gold sm:text-3xl" data-id="element-94" data-mp="2vil1muxgac50">
          ¿Y si en lugar de improvisar tuvieras claro qué hacer?
        </p>
      </div>
    </section>;
}